import { IHolisticRubricDescription } from '@/components/staffer/ExerciseBuilder/Rubric/useQuestionRubric';
import React, { useState } from 'react';
import Froala from '@/components/shared/Froala';
import cn from '@/utils/cn';
import I18n from 'i18n-js';
import styles
  from '@/components/staffer/ExerciseBuilder/Rubric/AddRubricModal/HolisticRubric/HolisticRubric.module.scss';

type EditorDescriptionCellProps = {
  data: IHolisticRubricDescription;
  locale?: Lowercase<Locale>;
  onDescriptionChange: (score: number, newDescription: string) => void;
};

const EditorDescriptionCell = ({
  data,
  locale = 'en',
  onDescriptionChange,
}: EditorDescriptionCellProps) => {
  const { score, description_en: descriptionEn, description_es: descriptionEs } = data;
  const [isToolbarVisible, setIsToolbarVisible] = useState(false);

  return (
    <>
      <Froala
        customConfig={{
          charCounterCount: false,
          height: 80,
          pastePlain: true,
          placeholderText: I18n.t('enter_text', { locale }),
          toolbarButtons: [
            ['bold', 'italic', 'underline', 'formatUL', 'clearFormatting'],
          ],
          toolbarContainer: `#toolbar-container-${score}`,
          width: 'auto',
        }}
        eventHandlers={[
          { blur: () => setIsToolbarVisible(false) },
          { focus: () => setIsToolbarVisible(true) },
        ]}
        modelType="RubricDescription"
        name={`description-${score}`}
        text={locale === 'en' ? descriptionEn || '' : descriptionEs || ''}
        userType="Admin"
        onChange={newDescription => onDescriptionChange(score, newDescription)}
      />
      <div
        className={
          cn(styles.holisticToolbarContainer,
            'tw-absolute -tw-top-[52px] tw-left-1/2 tw--translate-x-1/2',
            { 'tw-hidden': !isToolbarVisible })}
        id={`toolbar-container-${score}`}
      />
    </>
  );
};

export default EditorDescriptionCell;
